import {Alert, Container, Grid, Paper, styled} from "@mui/material";
import {useLocation, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import React, {useEffect} from "react";
import {getAllBatches} from "../features/allBatchesSlice";
import ExternalSourceBreadcrumbs from "../ExternalSourceManagement/ExternalSourceBreadcrumbs";
import Typography from "@mui/material/Typography";
import {batchCurrentStatus} from "../ExternalSourceManagement/ExternalSourceManagementHome";
import ExternalSourceBatchProgressBar from "../ExternalSourceManagement/ExternalSourceBatchProgressBar";
import TerminologyImportPanel from "./TerminologyImportPanel";
import {lookupTerminology} from "../utils/terminology";

/**
 * New-import page for any Amendment #1 A5 value set; which one comes from the :name route param.
 *
 * @date: 08/11/26
 * @copy: (C) Copyright 2026 MaxMD Corporation, All Rights Reserved.
 */

const StyledContainer = styled(Container)(({theme}) => ({
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
}))
const StyledPaper = styled(Paper)(({theme}) => ({
    padding: theme.spacing(2),
    overflow: 'auto',
    boxShadow: '0 7px 20px #cccccc',
    minHeight: '200px'
}))

export default function TerminologyNewImportTask() {
    const location = useLocation();
    const {name} = useParams();
    const dispatch = useDispatch();
    const terminology = lookupTerminology(name);

    const {terminologyBatches, batchRefresh} = useSelector(state => state.allBatches);
    const batches = (terminology && terminologyBatches[terminology.key]) || [];

    useEffect(() => {
        dispatch(getAllBatches());
    }, [batchRefresh, name])

    // A hand-typed or stale URL should say so rather than render a page that silently does nothing.
    if (!terminology) {
        return (
            <StyledContainer>
                <Alert severity='error'>Unknown value set "{name}".</Alert>
            </StyledContainer>
        )
    }

    return (
        <StyledContainer>
            <ExternalSourceBreadcrumbs path={location.pathname}/>
            <h3 className='title'>New {terminology.label} Import Task</h3>
            <Grid item xs={12} md={12} lg={12}>
                <h4>{terminology.label} ValueSet</h4>
                <StyledPaper sx={{minHeight: '120px'}}>
                    <Typography gutterBottom>Binds: {terminology.columns}</Typography>
                    <TerminologyImportPanel terminology={terminology}/>
                </StyledPaper>
            </Grid>
            <br/>
            <Grid item xs={12} md={12} lg={12}>
                <h4>{terminology.label} Import Progress</h4>
                <StyledPaper>
                    {batches.length > 0 && batches[0].status !== 'Init' &&
                        <Alert severity={batchCurrentStatus[batches[0].status].getStatus} icon={false}>
                            {batchCurrentStatus[batches[0].status].getMsg(terminology.label)}
                        </Alert>}
                    {batches.length > 0 && batches[0].status !== 'Completed' && batches[0].status !== 'Cancelled' && batches[0].status !== 'Failed' &&
                        <ExternalSourceBatchProgressBar batch={batches[0]}/>}
                </StyledPaper>
            </Grid>
        </StyledContainer>
    )
}
